import React from 'react';
import store from '../../store/Store';

import EditorTemplate from '../editorTemplate/EditorTemplate'
import EditorContent from '../editorContent/EditorContent'

import Navigation from '../navigation/Navigation'

import './editor.scss';

type editorState = {
	
}

type editorProps = {
	
}

class Editor extends React.Component<editorState, editorProps> {

  constructor(props) {
  	super(props)

  	this.state = {
  		
  	}
  }

  componentDidMount() {
	store.subscribe(() => {
		this.setState({
			
		})
	})
  }

  componentWillUnmount() {
	store.subscribe(() => {
		this.setState({
			
		})
	})
  }

  render() {
	  return (
	  	<div
	  		className="Editor"
	  		style={{
	  			width: '100vw',
	  			height: '100vh'
	  			// backgroundImage: 'url(images/editor-background.jpg)',
	  			// backgroundPosition: 'center',
				// backgroundRepeat: 'no-repeat',
				// backgroundSize: 'cover'
	  		}}
	  	>
	  		<div
				style={{
					position: 'absolute',
					top: 'calc(${ editor.selectedPage } * 100%)',
					left: '0',
					width: '100vw'
				}}
			>
				
			</div>

			<EditorContent
				article={ store.getState().article }
				navigation={ store.getState().navigation }
			/>

		</div>
	  );
	}
}

export default Editor;